import { getCMConnectionManager } from '@/server-events/connections';
import { ActiveUserData } from '@/types';

export class ProjectUsers {
    async getActiveBuyers() {
        return await getCMConnectionManager().invoke<ActiveUserData[]>('GetActiveBuyers');
    }

    addReceiveActiveBuyersHandler(handler: (users: ActiveUserData[]) => void) {
        getCMConnectionManager().on('ReceiveActiveBuyers', handler);
    }

    removeReceiveActiveBuyersHandler(handler: (users: ActiveUserData[]) => void) {
        getCMConnectionManager().off('ReceiveActiveBuyers', handler);
    }
}